import React from "react";
import { withRouter } from "react-router-dom";
import Layout from "./utilities/Layout";
import Agenda from "./Agenda";

class Home extends React.Component {
  render() {
    return (
      <Layout
        params={this.props.match.params}
        history={this.props.history}
        title="Calendrier"
      >
        <Agenda />
      </Layout>
    );
  }
}
export default withRouter(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js